export default {
    vehicleCode
}
export function vehicleCode(type) {
    var code = "02";
    switch (type) {
        case "大型汽车":
            code ="01";
            break;
        case "小型汽车":
            code = "02";
            break;
        case "使馆汽车":
            code = "03";
            break;
        case "领馆汽车":
            code = "04";
            break;
        case "境外汽车":
            code = "05";
            break;
        case "外籍汽车":
            code = "06";
            break;
        case "两、三轮摩托车":
            code = "07";
            break;
        case "轻便摩托车":
            code = "08";
            break;
        case "使馆摩托车":
            code = "09";
            break;
        case "领馆摩托车":
            code = "10";
            break;
        case "境外摩托车":
            code = "11";
            break;
        case "外籍摩托车":
            code = "12";
            break;
        case "农用摩托车":
            code = "13";
            break;
        case "拖拉机":
            code = "14";
            break;
        case "挂车":
            code = "15";
            break;
        case "教练汽车":
            code = "16";
            break;
        case "教练摩托车":
            code = "17";
            break;
        case "试验汽车":
            code = "18";
            break;
        case "试验摩托车":
            code = "19";
            break;
        // case "临时入境汽车":
        //     code = 18;
        //     break;
        // case "临时入境摩托车":
        //     code = 18;
        //     break;
        // case "临时行驶车":
        //     code = 18;
        //     break;
        // case "警用汽车":
        //     code = 18;
        //     break;
        // case "临时行驶车":
        //     code = 18;
        //     break;
        //     case "临时行驶车":
        //     code = 18;
        //     break;
        default:
            code = "02";
            break;
    }
    return code;
}
